import requests from './httpServices'

class AuthService {
  login(body) {
    return requests.post('/login', body)
  }
  register(body) {
    return requests.post('/register', body)
  }
  resetPassword(body) {
    return requests.post('/forgot_password', body)
  }
}

export default new AuthService()
